<template>
  <div class="standard">
    <el-dialog
      title="气象科普"
      :visible.sync="params.flag"
      v-dialogDrag
      :modal="false"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :modal-append-to-body="false"
      ref="qxkpRef"
      :before-close="
        () => params.flag && $parent.toggleProductView(params.productInfo.code)
      "
    >
      <div class="tabs">
        <span
          v-for="(item, index) in tabs"
          :key="index"
          :class="{ active: index == currentIndex }"
          @click="changeTab(index)"
          >{{ item }}
        </span>
      </div>
      <div class="content" v-if="isShow">
        <div class="item yujingItem" v-show="currentIndex === 0">
          <el-table :data="warringLevel" style="width: 100%" height="100%">
            <el-table-column prop="level" label="预警信号" width="100px">
              <template slot-scope="scope">
                <p>{{ scope.row.level }}</p>
                <img :src="scope.row.src" alt="" />
              </template>
            </el-table-column>
            <el-table-column prop="content" label="防御指引">
              <div slot-scope="scope" v-html="scope.row.content"></div>
            </el-table-column>
          </el-table>
        </div>
        <div class="item" v-show="currentIndex === 1">
          <el-table :data="rainLevel" style="width: 100%" height="100%">
            <el-table-column prop="level" label="降雨量名称"> </el-table-column>
            <el-table-column prop="twentyFour" label="12小时降雨量(mm)">
            </el-table-column>
            <el-table-column prop="twelve" label="24小时降雨量(mm)">
            </el-table-column>
          </el-table>
        </div>
        <div class="item" v-show="currentIndex === 2">
          <el-table :data="windLevel" style="width: 100%" height="100%">
            <el-table-column prop="level" label="风力级数" width="45px">
            </el-table-column>
            <el-table-column prop="name" label="名称" width="50px">
            </el-table-column>
            <el-table-column
              prop="twelve"
              label="相当于空旷平地上标准高度（10米）处的风速"
            >
              <el-table-column prop="section" label="节"> </el-table-column>
              <el-table-column prop="wind1" label="米/秒"> </el-table-column>
              <el-table-column prop="wind2" label="公里/小时">
              </el-table-column>
            </el-table-column>
          </el-table>
        </div>
        <div class="item typhoon-item" v-show="currentIndex === 3">
          <el-table :data="typhoonLevel" style="width: 100%" height="100%">
            <el-table-column prop="level" label="热带气旋的等级" width="140px">
            </el-table-column>
            <el-table-column
              prop="winds"
              label="底层中心附近最大平均风速/（m/s）"
            >
              <div class="table-two-cell" slot-scope="scope">
                <div>{{ scope.row.winds.split("-")[0] }}</div>
                <div
                  v-show="scope.row.winds.split('-')[1]"
                  class="tabel-cell-last"
                >
                  {{ scope.row.winds.split("-")[1] }}
                </div>
              </div>
            </el-table-column>
            <el-table-column prop="windd" label="底层中心附近最大平均风力/级">
              <div class="table-two-cell" slot-scope="scope">
                <div>{{ scope.row.windd.split("-")[0] }}</div>
                <div
                  v-show="scope.row.windd.split('-')[1]"
                  class="tabel-cell-last"
                >
                  {{ scope.row.windd.split("-")[1] }}
                </div>
              </div>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: ["params"],
  data() {
    return {
      isShow: true,
      currentIndex: 0,
      tabs: ["预警信号", "降雨", "风力", "台风"],
      warringLevel: [
        {
          level: "白色台风",
          src: require("@/assets/images/白色台风.png"),
          content: `含义： 48小时内将受台风影响。</br>
                    1、进入台风注意状态，警惕台风对当地的影响。</br>
                    2、注意通过气象信息传播渠道了解台风的最新情况。`,
        },
        {
          level: "蓝色台风",
          src: require("@/assets/images/蓝色台风.png"),
          content: `含义: 24小时内将受台风影响，平均风力可达6级以上，或者阵风8级以上；或者已经受台风影响，平均风力为6～7级，或者阵风8～9级并将持续。</br>
                    1、进入台风戒备状态，做好防御台风准备。</br>
                    2、注意了解台风最新消息和政府及有关部门防御台风通知。</br>
                    3、加固门窗和板房、铁皮屋、棚架等临时搭建物，妥善安置室外搁置物和悬挂物。</br>
                    4、海水养殖、海上作业人员应当适时撤离，船舶应当及时回港避风或者采取其他避风措施。`,
        },
        {
          level: "黄色台风",
          src: require("@/assets/images/黄色台风.png"),
          content: `含义： 24小时内将受台风影响，平均风力可达8级以上，或者阵风10级以上；或者已经受台风影响，平均风力为8～9级，    或者阵风10～11级并将持续。</br>
                  1、进入台风防御状态，密切关注台风最新消息和政府及有关部门发布的防御台风通知。</br>
                  2、中小学校、幼儿园、托儿所应当停课，未启程上学的学生不必到校上课；上学、放学途中的学生应当就近到安全场所暂避或者在安全情况下回家；学校应当妥善安置在校（含校车上、寄宿）学生，在确保安全的情况下安排学生离校回家。
                  3、居民应当关紧门窗，妥善安置室外搁置物和悬挂物，尽量避免外出；处于危险地带和危房中的人员应当及时撤离，确保留在安全场所。</br>
                  4、停止户外集体活动，停止高空等户外作业。</br>
                  5、滨海浴场、景区、公园、游乐场应当适时停止营业，关闭相关区域，组织人员避险。</br>
                  6、海水养殖、海上作业人员应当撤离，回港避风船舶不得擅自离港，并做好防御措施。</br>
                  7、相关应急处置部门和抢险单位加强值班，实时关注灾情，落实应对措施。`,
        },
        {
          level: "橙色台风",
          src: require("@/assets/images/橙色台风.png"),
          content: `含义：12小时内将受台风影响，平均风力可达10级以上，或者阵风12级以上；或者已经受台风影响，平均风力为10～11级，或者阵风12级以上并将持续。</br>
                    1、进入台风紧急防御状态，密切关注台风最新消息和政府及有关部门发布的防御台风通知。</br>
                    2、中小学校、幼儿园、托儿所应当停课，学校应当妥善安置寄宿学生。</br>
                    3、居民避免外出，确保留在安全场所。</br>
                    4、停止室内大型集会，立即疏散人员。</br>
                    5、滨海浴场、景区、公园、游乐场应当停止营业，迅速组织人员避险。</br>
                    6、加固港口设施；落实船舶防御措施，防止走锚、搁浅和碰撞。</br>
                    7、相关应急处置部门和抢险单位密切监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "红色台风",
          src: require("@/assets/images/红色台风.png"),
          content: `含义：12小时内将受或者已经受台风影响，平均风力可达12级以上，或者已达12级以上并将持续。</br>
                    1、进入台风特别紧急防御状态，密切关注台风最新消息和政府及有关部门发布的防御台风通知。</br>
                    2、中小学校、幼儿园、托儿所应当停课，学校应当妥善安置寄宿学生；建议用人单位停工（特殊行业除外），并为滞留人员提供安全的避风场所。
                    3、居民切勿外出，确保留在安全场所。</br>
                    4、当台风中心经过时风力会减小或者静止一段时间，应当保持戒备和防御，以防台风中心经过后强风再袭。</br>
                    4、当台风中心经过时风力会减小或者静止一段时间，应当保持戒备和防御，以防台风中心经过后强风再袭。</br>
                    5、相关应急处置部门和抢险单位严密监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "黄色暴雨",
          src: require("@/assets/images/黄色暴雨.png"),
          content: `含义： 6小时内本地将有暴雨发生，或者已经出现明显降雨，且降雨将持续。</br>
                    1、进入暴雨戒备状态，关注暴雨最新消息。</br>
                    2、中小学校、幼儿园、托儿所应当采取适当措施，保证学生和幼儿安全。</br>
                    3、驾驶人员应当注意道路积水和交通阻塞，确保安全。</br>
                    4、做好低洼、易涝地区的排水防涝工作。`,
        },
        {
          level: "橙色暴雨",
          src: require("@/assets/images/橙色暴雨.png"),
          content: `含义：在过去的3小时，本地降雨量已达50毫米以上，且降雨将持续。</br>
                    1、进入暴雨防御状态，密切关注暴雨最新消息。</br>
                    2、学生可以延迟上学；上学、放学途中的学生应当就近到安全场所暂避。</br>
                    3、暂停户外作业和活动，尽可能留在安全场所暂避。</br>
                    4、行驶车辆应当尽量绕开积水路段及下沉式立交桥，避免穿越水浸道路，避免将车辆停放在低洼易涝等危险区域</br>。
                    5、相关应急处置部门和抢险单位应当加强值班，密切监视灾情，对积水地区实行交通疏导和排水防涝；转移危险地带和危房中的人员到安全场所暂避。</br>
                    6、对低洼地段室外供用电设施采取安全防范措施。</br>
                    7、注意防范暴雨可能引发的内涝、山洪、滑坡、泥石流等灾害。`,
        },
        {
          level: "红色暴雨",
          src: require("@/assets/images/红色暴雨.png"),
          content: `含义：在过去的3小时，本地降雨量已达100毫米以上，且降雨将持续。</br>
                    1、进入暴雨紧急防御状态，密切关注暴雨最新消息和政府及有关部门发布的防御暴雨通知。</br>
                    2、中小学校、幼儿园、托儿所应当停课，未启程上学的学生不必到校上课；上学、放学途中的学生应当在安全情况下回家或者就近到安全场所暂避；学校应当保障在校（含校车上、寄宿）学生的安全。</br>
                    3、停止户外作业和活动，人员应当留在安全场所暂避；危险地带和危房中的人员应当撤离。</br>
                    4、地铁、地下商城、地下车库、地下通道等地下设施和场所的经营管理单位应当采取有效措施避免和减少损失，保障人员安全。</br>
                    5、对低洼地段室外供用电设施采取安全防范措施。</br>
                    6、行驶车辆应当就近到安全区域暂避，避免将车辆停放在低洼易涝等危险区域，如遇严重水浸等危险情况应当立即弃车逃生。</br>
                    7、相关应急处置部门和抢险单位应当严密监视灾情，做好暴雨及其引发的内涝、山洪、滑坡、泥石流等灾害应急抢险救灾工作。`,
        },
        {
          level: "黄色高温",
          src: require("@/assets/images/黄色高温.png"),
          content: `含义：天气闷热，24小时内最高气温将升至35℃或者已经达到35℃以上。</br>
                    1、注意防暑降温。</br>
                    2、避免长时间户外露天作业或者在高温条件下作业。</br>
                    3、加强防暑降温保健知识的宣传。`,
        },
        {
          level: "橙色高温",
          src: require("@/assets/images/橙色高温.png"),
          content: `含义：天气炎热，24小时内最高气温将升至37℃以上或者已经达到37℃以上。</br>
                    1、做好防暑降温，高温时段尽量避免户外活动，暂停户外露天作业。</br>
                    2、注意防范因电线、变压器等电力设备负载过大而引发火灾。</br>
                    3、注意作息时间，保证睡眠，必要时准备一些常用的防暑降温药品。</br>
                    4、有关单位落实防暑降温保障措施，提供防暑降温指导，有条件的地区开放避暑场所。`,
        },
        {
          level: "红色高温",
          src: require("@/assets/images/红色高温.png"),
          content: `含义：天气酷热，24小时内最高气温将升至39℃以上。</br>
                    1、采取有效措施防暑降温，白天尽量减少户外活动。</br>
                    2、对老、弱、病、幼、孕人群采取保护措施。</br>
                    3、除特殊行业外，停止户外露天作业。</br>
                    4、单位和个人要特别注意防火。</br>
                    5、有关单位按照职责采取防暑降温应急措施，有条件的地区开放避暑场所。`,
        },
        {
          level: "黄色寒冷",
          src: require("@/assets/images/黄色寒冷.png"),
          content: `含义： 预计因冷空气侵袭，当地气温在24小时内急剧下降10℃以上，或者日平均气温维持在12℃以下。</br>
                    1、关注寒冷天气最新消息和政府及有关部门发布的防御寒冷通知。</br>
                    2、注意做好防寒和防风工作，居民适时添衣保暖。`,
        },
        {
          level: "橙色寒冷",
          src: require("@/assets/images/橙色寒冷.png"),
          content: `含义：预计因冷空气侵袭，当地最低气温将降到5℃以下，或者日平均气温维持在10℃以下。</br>
                    1、密切关注寒冷天气最新消息和政府及有关部门发布的防御寒冷通知。</br>
                    2、居民尤其是老、弱、病、幼、孕人群做好防寒保暖工作。</br>
                    3、采取防寒救助措施，适时开放避寒场所。</br>
                    4、做好牲畜、家禽的防寒防风，对热带、亚热带水果及有关水产、农作物等采取防寒措施。</br>
                    5、高寒地区应当采取防霜冻、冰冻措施。`,
        },
        {
          level: "红色寒冷",
          src: require("@/assets/images/红色寒冷.png"),
          content: `含义： 预计因冷空气侵袭，当地最低气温将降到0℃以下，或者日平均气温维持在5℃以下。</br>
                    1、严密关注寒冷天气最新消息和政府及有关部门发布的防御寒冷通知。</br>
                    2、居民尤其是老、弱、病、幼、孕人群加强防寒保暖工作。</br>
                    3、采取防寒救助措施，开放避寒场所。</br>
                    4、农业、林业、水产业、畜牧业、交通运输、供电等单位应当采取防寒防冻措施</br>
                    5、相关应急处置部门和抢险单位应当做好灾害应急抢险救灾工作。`,
        },
        {
          level: "黄色大雾",
          src: require("@/assets/images/黄色大雾.png"),
          content: `含义：12小时内将出现能见度小于500米的雾，或者已经出现能见度小于500米、大于等于200米的雾且将持续。</br>
                    1、驾驶人员注意安全，小心驾驶。</br>
                    2、机场、轨道交通、高速公路、港口码头等经营管理单位加强管理，保障安全。</br>
                    3、户外活动注意安全。`,
        },
        {
          level: "橙色大雾",
          src: require("@/assets/images/橙色大雾.png"),
          content: `含义：6小时内将出现能见度小于200米的雾，或者已经出现能见度小于200米、大于等于50米的雾且将持续。</br>
                    1、驾驶人员应当控制车、船行驶速度，确保安全。</br>
                    2、机场、轨道交通、高速公路、港口码头等经营管理单位采取有效措施，加强调度指挥，保障安全。</br>
                    3、减少户外活动。`,
        },
        {
          level: "红色大雾",
          src: require("@/assets/images/红色大雾.png"),
          content: `含义： 2小时内将出现能见度低于50米的雾，或者已经出现能见度低于50米的雾且将持续。</br>
                    1、有关单位按照行业规定适时采取交通安全管制措施，如机场暂停飞机起降、高速公路暂时封闭、轮渡暂时停航等。</br>
                    2、各类机动交通工具采取有效措施保障安全。</br>
                    3、驾驶人员采取合理行驶方式，并尽快寻找安全停放区域停靠。</br>
                    4、避免户外活动。`,
        },
        {
          level: "黄色灰霾",
          src: require("@/assets/images/黄色灰霾.png"),
          content: `含义：12小时内将出现灰霾天气，或者已经出现灰霾天气且将持续。</br>
                    1、驾驶人员注意安全，小心驾驶。</br>
                    2、机场、高速公路、港口码头等经营管理单位采取措施，保障安全。</br>
                    3、居民需适当防护，减少户外活动，建议中小学校、幼儿园、托儿所适时停止户外活动。`,
        },
        {
          level: "黄色雷雨大风",
          src: require("@/assets/images/黄色雷雨大风.png"),
          content: `含义：6小时内本地将受雷雨天气影响，平均风力可达6级以上，或者阵风8级以上，并伴有强雷电；或者已经受雷雨天气影响，平均风力达6～7级，或者阵风8～9级，并伴有强雷电，且将持续。</br>
                    1、关注雷雨大风最新消息和有关防御通知，做好防御大风、雷电工作。</br>
                    2、及时停止户外集体活动，停止高空等户外作业。</br>
                    3、居民应当关紧门窗，妥善安置室外搁置物和悬挂物，尽量避免外出，留在有雷电防护装置的安全场所暂避。</br>
                    4、公园、景区、游乐场等户外场所应当做好防护措施，确保人员安全。</br>
                    5、采取必要措施，保障易受雷击的设备设施和场所的安全。</br>
                    6、机场、轨道交通、高速公路、港口码头等经营管理单位应当采取措施，保障安全。`,
        },
        {
          level: "橙色雷雨大风",
          src: require("@/assets/images/橙色雷雨大风.png"),
          content: `含义： 2小时内本地将受雷雨天气影响，平均风力可达8级以上，或者阵风10级以上，并伴有强雷电；或者已经受雷雨天气影响，平均风力为8～9级，或者阵风10～11级，并伴有强雷电，且将持续。</br>
                    1、密切关注雷雨大风最新消息和有关防御通知，迅速做好防御大风、雷电工作。</br>
                    2、立即停止户外活动和作业。</br>
                    3、居民应当关紧门窗，妥善安置室外搁置物和悬挂物。</br>
                    4、居民应当避免外出，远离户外广告牌、棚架、铁皮屋、板房等易被大风吹动的搭建物，切勿在树下、电杆下、塔吊下躲避，应当留在有雷电防护装置的安全场所暂避。</br>
                    5、公园、景区、游乐场等户外场所应当及时发出警示信息，适时关闭相关区域，停止营业，组织居民避险。</br>
                    6、在建工地应当采取防护措施，加强工棚、脚手架、井架等设施和塔吊、龙门吊、升降机等机械、电器设备的安全防护，保障居民安全。</br>
                    7、机场、轨道交通、高速公路、港口码头等经营管理单位应当迅速采取措施，确保安全。</br>
                    8、相关应急处置部门和抢险单位密切监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "红色雷雨大风",
          src: require("@/assets/images/红色雷雨大风.png"),
          content: `含义： 2小时内本地将受雷雨天气影响，平均风力可达10级以上，或者阵风12级以上，并伴有强雷电；或者已经受雷雨天气影响，平均风力为10级以上，或者阵风12级以上，并伴有强雷电，且将持续。</br>
                    1、严密关注雷雨大风最新消息和有关防御通知，迅速做好防御大风、雷电工作。</br>
                    2、立即停止户外活动和作业。</br>
                    3、居民应当关紧门窗，妥善安置室外搁置物和悬挂物。</br>
                    4、居民切勿外出，远离户外广告牌、棚架、铁皮屋、板房等易被大风吹动的搭建物，切勿在树下、电杆下、塔吊下躲避，应当留在有雷电防护装置的安全场所暂避。</br>
                    5、公园、景区、游乐场等户外场所应当立即发出警示信息，立即关闭相关区域，停止营业，组织人员避险。</br>
                    6、在建工地应当采取防护措施，加强工棚、脚手架、井架等设施和塔吊、龙门吊、升降机等机械、电器设备的安全防护，保障人员安全。</br>
                    7、机场、轨道交通、高速公路、港口码头等经营管理单位应当迅速采取措施，确保安全。</br>
                    8、相关应急处置部门和抢险单位密切监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "黄色道路结冰",
          src: require("@/assets/images/黄色道路结冰.png"),
          content: `含义：12小时内将出现对交通有影响的道路结冰。</br>
                    1、交通运输、公安机关交通管理等部门做好应对准备工作。</br>
                    2、驾驶人员注意路况，安全行驶。`,
        },
        {
          level: "橙色道路结冰",
          src: require("@/assets/images/橙色道路结冰.png"),
          content: `含义：6小时内将出现对交通有较大影响的道路结冰。</br>
                    1、行人出行注意防滑。</br>
                    2、交通运输、公安机关交通管理等部门注意指挥和疏导行驶车辆。</br>
                    3、驾驶人员应当采取防滑措施，听从指挥，慢速行驶。`,
        },
        {
          level: "红色道路结冰",
          src: require("@/assets/images/红色道路结冰.png"),
          content: `含义：2小时内将出现或者已经出现对交通有很大影响的道路结冰。</br>
                  1、居民尽量减少外出。</br>
                  2、有关部门适时采取交通安全管制措施，必要时封闭结冰道路。</br>
                  3、相关应急处置部门和抢险单位密切监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "橙色冰雹",
          src: require("@/assets/images/橙色冰雹.png"),
          content: `含义：6小时内将出现或者已经出现冰雹，并可能造成雹灾。</br>
                    1、户外人员及时到安全的场所暂避。</br>
                    2、妥善安置易受冰雹影响的室外物品、车辆等。</br>
                    3、将家禽、牲畜等赶到带有顶蓬的安全场所。</br>
                    4、相关应急处置部门和抢险单位随时准备启动抢险应急方案。`,
        },
        {
          level: "红色冰雹",
          src: require("@/assets/images/红色冰雹.png"),
          content: `含义：2小时内出现冰雹的可能性极大或者已经出现冰雹，并可能造成重雹灾。</br>
                    1、户外人员立即到安全的场所暂避。</br>
                    2、妥善安置易受冰雹影响的室外物品、车辆等。</br>
                    3、将家禽、牲畜等赶到带有顶蓬的安全场所。</br>
                    4、相关应急处置部门和抢险单位密切监视灾情，做好应急抢险救灾工作。`,
        },
        {
          level: "黄色森林火险",
          src: require("@/assets/images/黄色森林火险.png"),
          content: `含义：较高火险，森林火险气象等级为三级，林内可燃物较易燃烧，森林火灾较易发生。</br>
                    1、进入森林防火防御状态，有关单位应当加强森林防火宣传教育，普及用火安全指引。</br>
                    2、加强巡山护林和野外用火的监管工作。</br>
                    3、进入森林防火区，注意防火；森林防火区用火要做好防范措施，勿留火种。</br>
                    4、充分做好扑火救灾准备工作。`,
        },
        {
          level: "橙色森林火险",
          src: require("@/assets/images/橙色森林火险.png"),
          content: `含义：高火险，森林火险气象等级为四级，林内可燃物容易燃烧，森林火灾容易发生，火势蔓延速度快。</br>
                    1、进入森林防火临战状态，有关单位应当进一步加强森林防火宣传教育。</br>
                    2、加大巡山护林和野外用火的监管力度。</br>
                    3、加强检查，禁止携带火种进山，严格管制野外火源。</br>
                    4、充分做好扑火救灾准备工作。`,
        },
        {
          level: "红色森林火险",
          src: require("@/assets/images/红色森林火险.png"),
          content: `含义：极高火险，森林火险气象等级为五级，林内可燃物极易燃烧，森林火灾极易发生，火势蔓延速度极快。</br>
                    1、进入紧急防火状态，有关单位加强值班调度，密切注意林火信息动态。</br>
                    2、进一步加强巡山护林，落实各项防范措施，及时消除森林火灾隐患。</br>
                    3、严格检查，禁止携带火种进山，严格管制野外火源。</br>
                    4、政府可以发布命令，禁止一切野外用火，严格管理可能引发森林火灾的居民生活用火。</br>
                    5、做好扑火救灾充分准备工作，森林消防队伍要严阵以待。</br>
                    6、发生森林火灾时要及时、科学、安全扑救，确保人民群众生命财产安全。`,
        },
      ],
      rainLevel: [
        {
          level: "毛毛雨、小雨、阵雨",
          twentyFour: "0.1~4.9",
          twelve: "0.1~9.9",
        },
        { level: "小雨-中雨", twentyFour: "3.0~9.9", twelve: "5.0~16.9" },
        { level: "中雨", twentyFour: "5.0~14.9", twelve: "10.0~24.9" },
        { level: "中雨-大雨", twentyFour: "10.0~29.9", twelve: "17.0~37.9" },
        { level: "大雨", twentyFour: "15.0~22.9", twelve: "25.0~49.9" },
        { level: "大雨-暴雨", twentyFour: "23.0~49.9", twelve: "38.0~74.9" },
        { level: "暴雨", twentyFour: "30.0~69.9", twelve: "50。0~99.9" },
        {
          level: "暴雨-大暴雨",
          twentyFour: "50.0~104.9",
          twelve: "75.0~174.9",
        },
        { level: "大暴雨", twentyFour: "70.0~140.0", twelve: "100.0~140.0" },
        {
          level: "大暴雨-特大暴雨",
          twentyFour: "105.0~170.0",
          twelve: "175.0~300.0",
        },
        { level: "特大暴雨", twentyFour: ">=140.0", twelve: ">=250.0" },
      ],
      windLevel: [
        {
          level: "0",
          name: "静稳",
          section: "<1",
          wind1: "0~0.2",
          wind2: "<1",
        },
        {
          level: "1",
          name: "软风",
          section: "1~3",
          wind1: "0.3~1.5",
          wind2: "1~5",
        },
        {
          level: "2",
          name: "轻风",
          section: "4~6",
          wind1: "1.6~3.3",
          wind2: "6~11",
        },
        {
          level: "3",
          name: "微风",
          section: "7~10",
          wind1: "3.4~5.4",
          wind2: "12~19",
        },
        {
          level: "4",
          name: "和风",
          section: "11~16",
          wind1: "5.5~7.9",
          wind2: "20~28",
        },
        {
          level: "5",
          name: "清劲风",
          section: "17~21",
          wind1: "8.0~10.7",
          wind2: "29~38",
        },
        {
          level: "6",
          name: "强风",
          section: "22~27",
          wind1: "10.8~13.8",
          wind2: "39~49",
        },
        {
          level: "7",
          name: "疾风",
          section: "28~33",
          wind1: "13.9~17.1",
          wind2: "50~61",
        },
        {
          level: "8",
          name: "大风",
          section: "34~40",
          wind1: "17.2~20.7",
          wind2: "62~74",
        },
        {
          level: "9",
          name: "烈风",
          section: "41~47",
          wind1: "20.8~24.4",
          wind2: "75~88",
        },
        {
          level: "10",
          name: "狂风",
          section: "48~55",
          wind1: "24.5~28.4",
          wind2: "89~102",
        },
        {
          level: "11",
          name: "暴风",
          section: "56~63",
          wind1: "28.5~32.6",
          wind2: "103~117",
        },
        {
          level: "12",
          name: "飓风",
          section: "64~71",
          wind1: "32.7~36.9",
          wind2: "118~133",
        },
        {
          level: "13",
          name: "-",
          section: "72~80",
          wind1: "37.0~41.4",
          wind2: "134~149",
        },
        {
          level: "14",
          name: "-",
          section: "81~~89",
          wind1: "41.5~46.1",
          wind2: "150~166",
        },
        {
          level: "15",
          name: "-",
          section: "90~99",
          wind1: "46.2~50.9",
          wind2: "167~183",
        },
        {
          level: "16",
          name: "-",
          section: "100~108",
          wind1: "51.0~56.0",
          wind2: "184~201",
        },
        {
          level: "17",
          name: "-",
          section: "109~118",
          wind1: "56.1~61.2",
          wind2: "202~220",
        },
      ],
      typhoonLevel: [
        { level: "热带低压 (TD)", winds: "10.8~17.1", windd: "6~7" },
        { level: "热带风暴 （TS）", winds: "17.2~24.4", windd: "8~9" },
        { level: "强热带风暴 （STS）", winds: "24.5~32.6", windd: "10~11" },
        { level: "台风 （TY）", winds: "32.7~36.9-17.0~41.4", windd: "12-13" },
        {
          level: "强台风 （STY）",
          winds: "41.5~46.1-46.2~50.9",
          windd: "14-15",
        },
        {
          level: "超强台风 （SUPERTY）",
          winds: "51.0~56.0->=56.1",
          windd: "16-17",
        },
      ],
    };
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
      },
      immediate: true,
    },
  },
  methods: {
    changeTab(index) {
      this.currentIndex = index;
      this.isShow = false;
      setTimeout(() => {
        this.isShow = true;
      }, 100);
    },
    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.qxkpRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
};
</script>
<style lang="less" scoped>
.standard {
  display: flex;
  flex-direction: column;
  pointer-events: none;
  .tabs {
    padding: 0 0 1rem 0;
    span {
      border: 0;
      background: transparent;
      cursor: pointer;
      font-size: 1rem;
      font-weight: 600;
      color: #fff;
      margin-right: 2rem;
    }
    span.active {
      color: #81c3ff;
    }
  }
  .content {
    flex: 1;
    position: relative;
    .item {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      .el-table {
        background: transparent;
        text-align: center;
        border: 0;

        /deep/ tr {
          background: transparent;
          th {
            text-align: center;
            border: 0;
            font-size: 0.88rem;
            font-weight: 600;
            color: #fff;
            background: #3c7cb8;
          }
          td {
            text-align: center;
            font-size: 0.88rem;
            font-weight: 400;
            color: #fff;
            border: 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.1);
          }
          .print {
            width: 1.13rem;
            height: 1.13rem;
            background: url("../assets/images/打印.png") no-repeat;
            border: 0;
            cursor: pointer;
            background-size: 1.13rem 1.13rem;
          }
          .image {
            margin: 0.52vw;
            width: 1.09vw;
            cursor: pointer;
          }
        }
        /deep/ tr:hover td {
          background: #3c7cb8 !important;
        }

        .new {
          margin-left: 0.52vw;
          background-color: #f56c6c;
          border-radius: 0.32vw;
          color: #fff;
          display: inline-block;
          font-size: 0.43vw;
          height: 0.94vw;
          line-height: 0.94vw;
          padding: 0.1vw 0.31vw;
          text-align: center;
          white-space: nowrap;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb {
          border-radius: 5px;
          background: #273458;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-thumb:hover {
          border-radius: 5px;
          box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: #1b2230;
        }

        /deep/.el-table__body-wrapper::-webkit-scrollbar-track {
          border-radius: 5px;
          background: #0c4170;
        }
        /deep/.el-table__fixed-right-patch {
          background: #1f2c49;
          border: 0;
        }
      }
      .el-table::before,
      /deep/.el-table__fixed-right::before {
        background: transparent;
      }
    }
    .yujingItem {
      .el-table {
        /deep/ tr {
          th {
            text-align: left;
          }
          td {
            text-align: left;
          }
        }
      }
    }
    .typhoon-item {
      .el-table {
      }
      /deep/ .el-table .cell {
        padding: 0px;
      }
      .tabel-cell-last {
        margin: 0;
        padding: 0;
      }
    }
  }
  /deep/.el-dialog__wrapper {
    overflow: hidden;
    .el-dialog {
      width: 46.13rem;
      height: 70vh;
      pointer-events: auto;
    }
  }
}
/deep/ .tabel-cell-last {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}
</style>
